interface Connections {
    from: string;
    to: string;
    type: number;
}

export const removeDuplicates = (connections: Connections[]): Connections[] => {
    const seen = new Set<string>();

    return connections.filter((item) => {
        const key = `${item.from}-${item.to}-${item.type}`;

        if (seen.has(key)) {
            return false;
        }

        seen.add(key);
        return true;
    });
};
